module.exports = __webpack_public_path__ + "static/media/verifiedCheck.c258f0e6.png";